import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { IconButton, TableCell, Typography } from '@mui/material'
import { t } from 'i18next'
import { ContractLightDTO } from '../../store/types/models/Contract'
import { formatStringDate } from '../../store/utils/dateUtils'
import { StickyCell } from '../../styles/WorklogTableStyles'
import EmploymentMenuPopup from '../Popup/EmploymentMenuPopup'

type EmploymentRowProps = {
  onToggleExpand: () => void
  isOpen: boolean
  contract: ContractLightDTO
  isManagement: boolean
  onContractDeleted?: (id: string) => void
}

const EmploymentRow = ({ onToggleExpand, isOpen, contract, isManagement, onContractDeleted }: EmploymentRowProps) => {
  return (
    <>
      <TableCell sx={{ overflow: 'hidden', width: { lgUp: 300, lgDown: 100 }, maxWidth: 300, minWidth: 100 }}>
        <Typography variant="body2" fontWeight={500}>
          {contract.contractTypeValue}
        </Typography>
      </TableCell>
      <TableCell>{formatStringDate(contract.startDate)}</TableCell>
      <TableCell>
        {contract.indefiniteDuration || !contract.endDate
          ? t('page.employments.table.indefiniteDurationShort')
          : formatStringDate(contract.endDate)}
      </TableCell>
      <TableCell>{t(`page.employments.settlementsTypes.${contract.settlementMethod}`)}</TableCell>
      <TableCell>{contract.employmentPercentage} %</TableCell>
      <TableCell padding="checkbox">
        {contract.paidVacationPeriods?.[0] && (
          <IconButton size="small" onClick={onToggleExpand}>
            {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        )}
      </TableCell>
      {isManagement && (
        <StickyCell
          align="center"
          sx={{
            borderLeft: '2px solid',
            borderLeftColor: 'background.elevation8',
            right: 0,
            '&:hover': {
              cursor: 'auto',
            },
          }}
        >
          <EmploymentMenuPopup contract={contract} onDeleted={onContractDeleted} />
        </StickyCell>
      )}
    </>
  )
}

export default EmploymentRow
